import { render, staticRenderFns } from "./monthlyPurchaseSaleStock.vue?vue&type=template&id=44ac6bff&scoped=true"
import script from "./monthlyPurchaseSaleStock.vue?vue&type=script&lang=js"
export * from "./monthlyPurchaseSaleStock.vue?vue&type=script&lang=js"
import style0 from "./monthlyPurchaseSaleStock.vue?vue&type=style&index=0&id=44ac6bff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac6bff",
  null
  
)

export default component.exports